"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidClassLabelOrder = void 0;
const lodash_1 = __importDefault(require("lodash"));
const finley_types_1 = require("@finley-technologies/finley-types");
// Input set should be sorted by the caller
const isValidClassLabelOrder = (sortedClassLabels) => {
    // Validate input is sorted (clone to avoid mutation of original input)
    const clonedSortedInput = lodash_1.default.clone(sortedClassLabels).sort();
    if (!lodash_1.default.isEqual(sortedClassLabels, clonedSortedInput)) {
        return false;
    }
    // Get defined class label letters (A -> F)
    const validClassLabelLetters = Object.values(finley_types_1.CreditFacility.ClassLabel)
        .filter((label) => label.length === 1)
        .sort();
    // Construct class label map to hold labels that were found
    const classLabelMap = new Map(validClassLabelLetters.map((label) => [label, []]));
    // Letters must be used in order
    let currentLetterIndex = 0;
    for (const classLabel of sortedClassLabels) {
        // Get letter for label
        const classLabelLetter = classLabel.charAt(0);
        // Get number for label if provided, otherwise '' becomes 1
        const classLabelNumber = Number(classLabel.slice(1)) || 1;
        const classLabelNumbers = classLabelMap.get(classLabelLetter);
        // If not already set, the input label is an invalid letter
        if (!classLabelNumbers) {
            return false;
        }
        // Check letter
        if (validClassLabelLetters[currentLetterIndex] === classLabelLetter) {
            // Same letter, don't update index
            // no-op
        }
        else if (validClassLabelLetters[currentLetterIndex + 1] === classLabelLetter) {
            // Next letter, update index
            currentLetterIndex += 1;
        }
        else {
            // Letter does not match current or next letter, invalid sequence
            return false;
        }
        // At this point, letter was valid, now check number
        // Set number in array
        classLabelNumbers.push(classLabelNumber);
        // Validate numbers match expected sequence
        const arrayLength = classLabelNumbers.length;
        const expectedSequence = new Array(arrayLength)
            .fill(null)
            .map((_element, idx) => idx + 1);
        if (!lodash_1.default.isEqual(classLabelNumbers, expectedSequence)) {
            return false;
        }
    }
    return true;
};
exports.isValidClassLabelOrder = isValidClassLabelOrder;
//# sourceMappingURL=validation.js.map